// extracted by mini-css-extract-plugin
export default {"wrap":"fourF_wrap__yMzZQ","pfor":"fourF_pfor__iRKGa","linkGFi":"fourF_linkGFi__p7sM5"};